module.exports = __webpack_public_path__ + "img/defaultImg.ad57c1de.png";